import { Alert } from '../../../../../../../../../mads';
import { useI18n } from '../../../../../../../../../shared/I18n';

import React from 'react';

interface SubmissionFailureNotificationProps {
    id?: string;
    handleClearError: () => void;
}

const SubmissionFailureNotification = (props: SubmissionFailureNotificationProps) => {
    const { pgettext, gettext } = useI18n();
    return (
        <Alert
            status="critical"
            title={pgettext(
                'Toast title text when qualification save was not successful',
                'Your preference was not saved',
            )}
            explainerText={pgettext(
                'Toast text when qualification save was not successful',
                'Something went wrong on our end.  Try again later.',
            )}
            dismissAction={{
                ariaLabel: gettext('Dismiss'),
                onDismiss: props.handleClearError,
            }}
        />
    );
};

export default SubmissionFailureNotification;
